// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { focusStyles } from "@store/Themes/common/mixins/common";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";
import { ButtonIcon } from "@store/MobiusOverrides/Button/Props";

const padding = pxToRemArray([20, 26]);

const buttonStyle = () => css`
    background-color: ${getColor("common.background")};
    border-color: ${getColor("common.background")};
`;

const modal: Styleguide["modal"] = {
    defaultProps: {
        closeButtonProps: {
            css: css`
                ${buttonStyle()};
                width: ${pxToRem(50)};
                padding: 0;
                ${focusStyles()}

                :hover {
                    > ${ButtonIcon} {
                        color: ${getColor("primary")};
                    }
                    border-color: ${getColor("common.background")};
                    background-color: ${getColor("common.background")};
                }
            `,
        },
    },
};

export default modal;
